import React from "react";
import "@aws-amplify/ui-react/styles.css"; // eslint-disable-line
import "../assets/theme.css";

const Theme = () => <React.Fragment></React.Fragment>;

export default Theme;
